interface ListIntoSentenceProps {
  list: string[];
  maximumNumberOfCharactersAllowed: number;
  separator: string;
  andSeparator: string;
  moreConstructor: (count: number) => string;
}
export const AveragePerCharacterWidth = 8;
export const listIntoSentence = ({
  list,
  separator,
  andSeparator,
  moreConstructor,
  maximumNumberOfCharactersAllowed,
}: ListIntoSentenceProps) => {
  if (list.length === 0) {
    return '';
  }
  if (list.length === 1) {
    return list[0];
  }

  return list.reduce((text, item, index) => {
    const isFirstItem = index === 0;
    const isAlreadyEnded = text.includes(andSeparator);

    if (isFirstItem || isAlreadyEnded) {
      return text;
    }
    const isLastItem = index === list.length - 1;

    if (isLastItem) {
      const textWithActualItem = `${text}${andSeparator}${item}`;

      if (textWithActualItem.length > maximumNumberOfCharactersAllowed) {
        return `${text}${andSeparator}${moreConstructor(1)}`;
      }

      return textWithActualItem;
    }
    const textWithActualItem = `${text}${separator}${item}`;

    if (textWithActualItem.length > maximumNumberOfCharactersAllowed) {
      return text + andSeparator + moreConstructor(list.length - index);
    }

    return textWithActualItem;
  }, list[0]);
};
